<script>
  import { createEventDispatcher } from "svelte";

  export let text = "";
  export let active;

  const dispatch = createEventDispatcher();

  function toggle() {
    active = !active;
    dispatch("change", active);
  }
</script>

<div
  class="toggle_wrapper"
  on:keypress={() => {}}
  on:click={toggle}
>
  <div class="toggle_text">{text}</div>
  <div class="toggle">
    {#if active}
      <svg
        width="29"
        height="14"
        viewBox="0 0 29 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 14C5.05556 14 3.40278 13.3203 2.04165 11.9609C0.680551 10.6015 0 8.95078 0 7.00875C0 5.06675 0.680551 3.41312 2.04165 2.04787C3.40278 0.682624 5.05556 0 7 0H21.8936C23.8381 0 25.4908 0.679708 26.852 2.03912C28.2131 3.39851 28.8936 5.04922 28.8936 6.99125C28.8936 8.93325 28.2131 10.5869 26.852 11.9521C25.4908 13.3174 23.8381 14 21.8936 14H7ZM7 13.1809H21.8936C23.612 13.1809 25.0717 12.5809 26.2728 11.3809C27.4739 10.181 28.0745 8.72266 28.0745 7.00592C28.0745 5.28921 27.4739 3.8289 26.2728 2.625C25.0717 1.4211 23.612 0.819149 21.8936 0.819149H7C5.28165 0.819149 3.82191 1.41913 2.62079 2.61908C1.4197 3.81901 0.819149 5.27734 0.819149 6.99408C0.819149 8.71079 1.4197 10.1711 2.62079 11.375C3.82191 12.5789 5.28165 13.1809 7 13.1809ZM21.8827 10.2766C22.8026 10.2766 23.5867 9.96229 24.235 9.33368C24.8833 8.7051 25.2074 7.92939 25.2074 7.00655C25.2074 6.08374 24.8855 5.30585 24.2416 4.67287C23.5976 4.03989 22.8157 3.7234 21.8958 3.7234C20.9759 3.7234 20.1995 4.0377 19.5665 4.66628C18.9335 5.29489 18.617 6.07061 18.617 6.99345C18.617 7.91626 18.9313 8.69415 19.5599 9.32713C20.1885 9.96011 20.9628 10.2766 21.8827 10.2766Z"
          fill="#1c1c20"
        />
      </svg>
    {:else}
      <svg
        class="inactive"
        width="29"
        height="14"
        viewBox="0 0 29 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.8936 -6.11959e-07C23.838 -4.41971e-07 25.4908 0.679708 26.8519 2.03912C28.213 3.39851 28.8936 5.04922 28.8936 6.99125C28.8936 8.93325 28.213 10.5869 26.8519 11.9521C25.4908 13.3174 23.838 14 21.8936 14L6.99994 14C5.0555 14 3.40272 13.3203 2.0416 11.9609C0.680493 10.6015 -5.86864e-05 8.95078 -5.85166e-05 7.00875C-5.83468e-05 5.06674 0.680493 3.41312 2.0416 2.04787C3.40272 0.682622 5.05551 -2.08399e-06 6.99994 -1.914e-06L21.8936 -6.11959e-07ZM21.8936 0.819148L6.99994 0.819147C5.28159 0.819147 3.82187 1.41912 2.62077 2.61908C1.41965 3.81901 0.819091 5.27734 0.819091 6.99408C0.81909 8.71079 1.41965 10.1711 2.62077 11.375C3.82187 12.5789 5.28159 13.1808 6.99994 13.1808L21.8936 13.1809C23.6119 13.1809 25.0716 12.5809 26.2728 11.3809C27.4739 10.181 28.0744 8.72266 28.0744 7.00592C28.0744 5.28921 27.4739 3.8289 26.2728 2.625C25.0716 1.4211 23.6119 0.819149 21.8936 0.819148ZM7.01089 3.7234C6.09098 3.7234 5.30688 4.03771 4.65859 4.66632C4.01027 5.2949 3.68611 6.07061 3.68611 6.99345C3.68611 7.91625 4.00807 8.69415 4.652 9.32713C5.29592 9.9601 6.07784 10.2766 6.99774 10.2766C7.91765 10.2766 8.69409 9.9623 9.32707 9.33372C9.96005 8.70511 10.2765 7.92938 10.2765 7.00655C10.2765 6.08374 9.96224 5.30585 9.33366 4.67287C8.70505 4.03989 7.93079 3.7234 7.01089 3.7234Z"
          fill="#1c1c20"
        />
      </svg>
    {/if}
  </div>
</div>

<style>
  .toggle_wrapper {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    height: 2rem;
    align-items: center;
    cursor: pointer;
  }

  .toggle {
    cursor: pointer;
    display: flex;
    justify-content: flex-end;
  }

  .toggle svg {
    height: 1rem;
    width: auto;
  }

  .inactive {
    opacity: 50%;
  }
</style>
